import React from 'react';
import styles from './LoadingOverlay.module.css';

interface LoadingOverlayProps {
  label?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ label = 'Loading...' }) => {
  return (
    <div className={styles.overlay} role="status" aria-live="polite" aria-label={label}>
      <div className={styles.card}>
        <div className={styles.spinner} />
        <div className={styles.label}>{label}</div>
      </div>
    </div>
  );
};
